/** Maps network webpage settings to the CSS variables used by the v2 top menu. */
export const TOP_MENU_DEFAULTS = {
  bg: '#1f2530',
  accent: '#e6c229',
  font: 'inherit',
};

const HEX_RE = /^#?([0-9a-f]{3}|[0-9a-f]{6})([0-9a-f]{2})?$/i;

/** Relative brightness 0..1 of a hex colour, or null when it is not a hex colour. */
export function colorLuminance(color: string): number | null {
  const match = HEX_RE.exec((color || '').trim());
  if (!match) {
    return null;
  }
  let hex = match[1];
  if (hex.length === 3) {
    hex = hex.split('').map((c) => c + c).join('');
  }
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
}

/** Black or white, whichever reads better on the given background. */
export function readableInk(background: string): string {
  const lum = colorLuminance(background);
  return lum !== null && lum > 0.6 ? '#14161a' : '#ffffff';
}

/** Brightness gap below which text on a colour is hard to read (white on yellow is about 0.26). */
export const MIN_INK_CONTRAST = 0.4;

/** The network's text colour when it reads on the background, else black or white. */
export function inkOn(background: string, preferred?: string): string {
  const bgLum = colorLuminance(background);
  const inkLum = colorLuminance(preferred || '');
  if (preferred && (bgLum === null || inkLum === null || Math.abs(bgLum - inkLum) >= MIN_INK_CONTRAST)) {
    return preferred;
  }
  return readableInk(background);
}

export function buildTopMenuVars(settings: any): { [name: string]: string } {
  const bg = settings?.main_bg_color || TOP_MENU_DEFAULTS.bg;
  const accent = settings?.bg_primary_color || TOP_MENU_DEFAULTS.accent;
  return {
    '--tm-bg': bg,
    '--tm-accent': accent,
    '--tm-on-accent': inkOn(accent, settings?.font_primary_color),
    '--tm-ink': readableInk(bg),
    // Accent used as text on the menu background (affiliate link, panel icons and dates).
    '--tm-accent-text': inkOn(bg, accent),
    '--tm-font': settings?.font_family || TOP_MENU_DEFAULTS.font,
  };
}
